import type { BrandConfig } from "./BrandLandingPage";

/**
 * Brand landing registry. Slugs map to the exact DB `brand` value used
 * in the `products` table — keep them in sync. Each entry powers the
 * route `/marca/<slug>`.
 */
export const BRAND_LANDINGS: Record<string, BrandConfig> = {
  optimum: {
    slug: "optimum",
    brand: "Optimum Nutrition",
    displayName: "Optimum Nutrition",
    tagline:
      "Líder mundial en proteína whey: Gold Standard 100% Whey, creatina y aminoácidos con calidad certificada.",
    description:
      "Optimum Nutrition (ON) es una de las marcas de suplementación deportiva más reconocidas del mundo, con más de 35 años perfeccionando su línea Gold Standard 100% Whey. En NutriMarket traemos directamente los productos originales con envío a toda República Dominicana: proteína whey, creatina monohidratada, BCAA y pre-entrenos. Ideal para atletas, fitness y quienes buscan un suplemento con respaldo clínico y excelente perfil de macros.",
    heroAccent: "linear-gradient(135deg, #c7261f 0%, #7a0b0b 100%)",
    logoEmoji: "🥇",
  },
  dymatize: {
    slug: "dymatize",
    brand: "Dymatize",
    displayName: "Dymatize",
    tagline:
      "Proteína ISO100 hidrolizada de absorción ultra-rápida, sin gluten ni lactosa — pureza certificada.",
    description:
      "Dymatize es referencia global en proteína de alta pureza, famosa por su ISO100: un aislado hidrolizado de suero con 25g de proteína y cero azúcar por servida. En NutriMarket te conectamos con la línea completa Dymatize disponible en República Dominicana — perfecta para post-entreno, ganancia de masa magra y dietas con control de carbohidratos. Envío a Santo Domingo, Santiago, Punta Cana y todo el país.",
    heroAccent: "linear-gradient(135deg, #1f2937 0%, #0b3a82 100%)",
    logoEmoji: "💪",
  },
};

export const BRAND_SLUGS = Object.keys(BRAND_LANDINGS);